const USER_LOGIN_KEY = "USER_LOGIN";

export function setUserInfo(userInfo) {
  localStorage.setItem(USER_LOGIN_KEY, JSON.stringify(userInfo));
}

export function getUserInfo() {
  const userInfoStr = localStorage.getItem(USER_LOGIN_KEY);
  if (userInfoStr) {
    try {
      return JSON.parse(userInfoStr);
    } catch (e) {
      return null;
    }
  }
  return null;
}

export function isLoggedIn() {
  return !!getUserInfo();
}

export function clearUserInfo() {
  localStorage.removeItem(USER_LOGIN_KEY);
  localStorage.removeItem("token");
}
